import styled, { css } from 'styled-components';
import { Container } from './PurchaseSubHeaderMvp/styles';

interface LongSteelContainerProps {
  showVerticalCrossSell?: boolean;
}

export const LongSteelContainer = styled(Container)<LongSteelContainerProps>`
  padding-bottom: 6rem;

  ${({ showVerticalCrossSell }) =>
    showVerticalCrossSell &&
    css`
      display: grid;
      grid-template-columns: 1fr 1fr 20rem;
      grid-template-rows: 9.0625rem 1fr;
      width: 100%;

      > *:nth-child(1) {
        grid-column: span 2;
        width: 100%;
      }

      > *:nth-child(2) {
        grid-column: span 2;
        width: 100%;
      }

      > *:nth-child(3) {
        grid-column: 3;
        grid-row: 1 / 3;
      }
    `}
`;
